import type { MissionChangeLogChange } from '../../types';
import { MissionChangeLogDiffRow } from '../mission-change-log-diff-row/mission-change-log-diff-row';
import styles from './mission-change-log-diff-list.module.scss';

type MissionChangeLogDiffListProps = {
  diffList: MissionChangeLogChange[];
};

export const MissionChangeLogDiffList = ({
  diffList,
}: MissionChangeLogDiffListProps) => (
  <div className={styles.container}>
    {diffList.map((diff, index) => (
      <MissionChangeLogDiffRow key={index} diffRow={diff} />
    ))}
  </div>
);
